import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import { format, addDays } from "date-fns";
import Modal from "react-modal";
// import { toast } from "react-toastify";
import CommonFilterStructure from "../../common-components/CommonFilterStructure";
import {
  fetchSubsPartialPendingData,
  fetchSubsPartialStatsData,
} from "../../../redux/reducers/apiSlice";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../PaymentLinkTable";
import {
  // convertStraight,
  convertThenFormat,
  formattedLongDate2,
} from "../../common-data/Converts";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import PMTopStructure from "../partial-payment/PMTopStructure";
// import {
//   subscriptionDraftorderCashfree,
//   updatePayment,
// } from "../../../redux/reducers/postApiSlice";
// import { showConfirmAlert } from "../../components-react/ReactAlert";
import PendingPMLinkMobile from "./PendingPMLinkMobile";
// import PaymentInfoMobile from "./PaymentInfoMobile";
import PartialCards from "./PartialCards";
import MealsStructure from "../../diet/meal/MealsStructure";
import OnlineCashCollect from "../partial-payment/online-cash-partial-payments/OnlineCashCollect";

const PMLinkStructure = ({ isCustom, handleBack, userInfoData }) => {
  const dispatch = useDispatch();

  const { subsPartialPendingLoading, subsPartialStats, subsPartialPending } =
    useSelector((state) => state.api);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";

  const [isPage, setIsPage] = useState(0);
  const iniAllFilter = {
    selectedGym:
      !isAdmin && !isClusterManager
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    selectedSubsType: "",
    selectedPlan: "",
    selFilterType: "",
    selectedStartDate: "",
    selectedEndDate: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    limit: 10,
    page: isPage + 1,
    gym_id: allFilters.selectedGym?.value || "",
    type: allFilters.selectedSubsType?.value || "",
    duration: allFilters.selectedPlan?.value || "",
    date_from: allFilters.selectedStartDate || "",
    date_to: allFilters.selectedEndDate || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [openDateRanger, setOpenDateRanger] = useState(false);
  const initialRangeState = [
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ];
  const [rangeState, setRangeState] = useState(initialRangeState);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniPartialData = {
    partialDatas: [],
    pagination: [],
    partialStats: {},
  };
  const [partialData, setPartialData] = useState(iniPartialData);
  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    partialInfo: [],
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const onClickReset = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const onCloseModal = () => {
    setModValues(iniModvalues);
  };

  const handleDateRangeChange = (item) => {
    setRangeState([item?.selection]);

    const formattedStartDate = format(item?.selection?.startDate, "yyyy-MM-dd");
    const formattedEndDate = format(item?.selection?.endDate, "yyyy-MM-dd");

    setAllFilters((prevs) => ({
      ...prevs,
      selectedStartDate: formattedStartDate,
      selectedEndDate: formattedEndDate,
    }));
  };

  const clearDateRanger = () => {
    setOpenDateRanger(false);
    setRangeState(initialRangeState);
    setAllFilters((prevs) => ({
      ...prevs,
      selectedStartDate: "",
      selectedEndDate: "",
    }));
  };

  const onClickSearch = () => {
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getAllPartialStatsData(filters) {
    const { page, limit, ...rest } = filters;

    dispatch(
      fetchSubsPartialStatsData({
        filters: rest,
        token: userInfoData?.token,
      })
    );
  }

  function getAllPartialData(filters) {
    dispatch(
      fetchSubsPartialPendingData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  // useEffect(() => {
  //   setAllFilters((prevs) => ({
  //     ...prevs,
  //     selectedGym: !isAdmin
  //       ? {
  //           label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
  //           value:
  //             userInfoData?.gym_id ||
  //             userInfoData?.user_id ||
  //             userInfoData?.uid ||
  //             "",
  //         }
  //       : "",
  //   }));
  // }, [userInfoData?.gym_id]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      gym_id: allFilters.selectedGym?.value || "",
      type: allFilters.selectedSubsType?.value || "",
      duration: allFilters.selectedPlan?.value || "",
      filter_type: allFilters.selFilterType || "",
      date_from: allFilters.selectedStartDate || "",
      date_to: allFilters.selectedEndDate || "",
    }));
  }, [
    allFilters.selectedGym,
    allFilters.selectedSubsType,
    allFilters.selectedPlan,
    allFilters.selFilterType,
    allFilters.selectedStartDate,
    allFilters.selectedEndDate,
    isPage,
  ]);

  useEffect(() => {
    getAllPartialStatsData(filters);
  }, [
    filters.gym_id,
    filters.type,
    filters.duration,
    filters.filter_type,
    filters.date_from,
    filters.date_to,
  ]);

  useEffect(() => {
    getAllPartialData(filters);
  }, [filters]);

  useEffect(() => {
    if (subsPartialStats?.status && subsPartialStats?.data?.length > 0) {
      setPartialData((prevs) => ({
        ...prevs,
        partialStats: subsPartialStats.data?.[0],
      }));
    } else {
      setPartialData((prevs) => ({
        ...prevs,
        partialStats: {},
      }));
    }
  }, [subsPartialStats]);

  useEffect(() => {
    if (subsPartialPending?.status && subsPartialPending?.data?.length > 0) {
      setPartialData((prevs) => ({
        ...prevs,
        partialDatas: subsPartialPending.data,
        pagination: subsPartialPending?.pagination || [],
      }));
    } else {
      setPartialData((prevs) => ({
        ...prevs,
        partialDatas: [],
        pagination: [],
      }));
    }
  }, [subsPartialPending]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
    }
  }, [allFilters.searchString]);

  const tbColumns = [
    {
      dataField: "name",
      text: "name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.name || "NA"} <br />{" "}
            <small style={{ textDecoration: "underline" }}>
              {" "}
              {row?.mobile || ""}{" "}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">
            <small>{row?.gym_name || "NA"}</small>
          </span>
        );
      },
    },
    {
      dataField: "price",
      text: "Total Amount",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth90">
            ₹{convertThenFormat(row?.price || 0)}
          </span>
        );
      },
    },
    {
      dataField: "total_pending",
      text: "Pending Amount",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth90">
            ₹{convertThenFormat(row?.total_pending || 0)}
          </span>
        );
      },
    },
    {
      dataField: "plan_name",
      text: "Plan",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth90">
            {row?.plan_name?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    // {
    //   dataField: "price",
    //   text: "Pending/Total Amount",
    //   formatter: (cell, row) => {
    //     return (
    //       <span className="tb-data minWidth150">
    //         ₹{convertThenFormat(row?.total_pending || 0)} /{" "}
    //         {convertThenFormat(row?.price || 0)} <br />
    //         <small>{row?.plan_name?.replace(/_/g, " ") || ""}</small>
    //       </span>
    //     );
    //   },
    // },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formattedLongDate2(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "payment_details_all",
      text: "Payment Status",
      formatter: (cell, row) => {
        const totalPendings =
          row?.payment_details_all?.length > 0 &&
          row.payment_details_all.filter((val) => val?.status === "pending")
            .length;

        return (
          <span
            className="tb-data hoverBlue"
            style={{
              textDecoration: "underline",
              fontWeight: "700",
              color: "#5F5DF0",
            }}
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "partial-info",
                partialInfo: row?.payment_details_all,
              }))
            }
          >{`${totalPendings} Pending`}</span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Details Modal"
        ariaHideApp={false}
      >
        <div className={`createNewCTOModalContainer`}>
          <ModalHeadAndClose
            title={`${
              modValues.cardName === "add"
                ? "Create New Partial Link"
                : modValues.cardName?.replace(/-/g, " ")
            }`}
            onClose={onCloseModal}
          />

          {modValues.cardName === "partial-info" ? (
            <>
              <OnlineCashCollect
                tbData={modValues.partialInfo}
                userInfoData={userInfoData}
                callFunction={() => {
                  getAllPartialStatsData(filters);
                  getAllPartialData(filters);
                  onCloseModal();
                }}
              />
            </>
          ) : modValues.cardName === "add" ? (
            <PMTopStructure decryptedText={userInfoData} isOpen={true} />
          ) : null}
        </div>
      </Modal>

      <Row>
        <Col>
          <MealsStructure
            text={"Pending Partial Payments"}
            isReload={() => getAllPartialData(filters)}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <CommonFilterStructure
            from="partial-payment-link"
            decryptedText={userInfoData}
            setFilters={setAllFilters}
            filters={allFilters}
            openDateRanger={openDateRanger}
            onClickReset={onClickReset}
            handleDateRangeChange={handleDateRangeChange}
            setOpenDateRanger={setOpenDateRanger}
            rangeState={rangeState}
            clearDateRanger={clearDateRanger}
            onClickSearch={onClickSearch}
            searchFilterApplied={searchFilterApplied}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <PartialCards
            partialStatsData={partialData.partialStats}
            prevAllFilters={allFilters}
            prevSetAllFilters={setAllFilters}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          {subsPartialPendingLoading ? (
            <ReactVortoxSpinner />
          ) : (
            <>
              <div className="fullWidthFlexCenter overflowAuto separatedTable">
                <PaymentLinkTable
                  tableData={partialData.partialDatas}
                  tableColumns={tbColumns}
                  tablePagination={partialData.pagination}
                  isPage={isPage}
                  setIsPage={setIsPage}
                />
              </div>

              <div className="lead-logs-card-container only-mobile">
                <PendingPMLinkMobile
                  tableData={partialData.partialDatas}
                  tablePagination={partialData.pagination}
                  isPage={isPage}
                  setIsPage={setIsPage}
                  setModValues={setModValues}
                />
              </div>
            </>
          )}
        </Col>
      </Row>
    </>
  );
};

export default PMLinkStructure;
